import { inject, Injectable } from '@angular/core';
import { iteratee } from 'lodash';
import { RdGameService } from '../games/rd-game';

interface IResPlayer{
  playerId: number,
  points: number
}

interface ITeamEvent{
  cardId: number,
  count_p: number,
  results: Array<IResPlayer>
}

@Injectable({
  providedIn: 'root'
})
export class TeamEvent {
  listResultTeams: Array<ITeamEvent> = [];
  cardResult: ITeamEvent | number;
  rdb = inject(RdGameService);

  init(list: any = []){
    this.listResultTeams = list;
  }

  fn(card: any, player_id: number, points: number, playerLeng: number){
    if(card.data?.influence.other){
      this.addReasult(card.card_id, player_id, points, playerLeng);
    }
  }

  addReasult(card_id: number, player_id: number, points: number, playerLeng: number){
    this.cardResult = this.findCardResult(card_id);
    if(this.cardResult){
      this.listResultTeams.forEach((item: ITeamEvent)=>{
        if(item.cardId === card_id){
          item.results.push({playerId: player_id, points});
        }
      });
    }else{
      let res:Array<IResPlayer> = [];
      res.push({playerId: player_id, points})
      this.listResultTeams.push({
        cardId: card_id,
        count_p: playerLeng,
        results: res
      });
    }
    // TODO перевірити роботу і тільки після цього зберігати
    this.addBD();
  }

  findCardResult(card_id: number){
    if(this.listResultTeams.length){
      return this.listResultTeams.find((item: ITeamEvent)=> item.cardId === card_id) || 0;
    }else{
      return 0;
    }
  }

  private addBD(){
    this.rdb.addTeamEvent(this.listResultTeams);
  }

  
}
